module.exports = __webpack_public_path__ + "static/media/012.3cb909d0.jpg";